export const sanitizeDomainList = (domains, availableDomains) => {
  const storedDomains = Array.isArray(domains) ? domains : [];
  const available = Array.isArray(availableDomains) ? availableDomains : [];

  const kept = [];
  storedDomains.forEach((domain) => {
    if (typeof domain !== "string") return;
    if (!available.includes(domain)) return;
    if (kept.includes(domain)) return;
    kept.push(domain);
  });

  if (Array.isArray(domains) && kept.length === domains.length) {
    return domains;
  }
  return kept;
};

export const protectClientDomain = (excludedDomains, clientDomain) => {
  if (!clientDomain) return excludedDomains;

  const isClientExcluded = excludedDomains.includes(clientDomain);
  if (!isClientExcluded) return excludedDomains;

  return excludedDomains.filter((domain) => domain !== clientDomain);
};
